import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LabelsService } from 'modules/inventory/settings/labels/services';
import { LABELS_LIST_KEY } from 'modules/inventory/settings/labels/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteLabels = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('labels');
  return useMutation(() => LabelsService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries([LABELS_LIST_KEY]);
      queryClient.invalidateQueries([id]);
    },
  });
};
